<template>
    <div>
        <div class="modal-container has-background-sBlue">

            <div class="modal-header">
                 Verify Access Code
            </div>

            <div class="modal-body has-background-sBlue">
                Please enter the code that was sent to your email account to verify your access.
                If you did not receive it in your inbox please be sure to check your junk-email folder.
                You can also click <a href="" @click.prevent="resend" class="has-text-warning">here</a> to have it resent.
                <form @submit.prevent="checkCode">
                    <div class="top20 has-text-centered" >
                        <input id="textInput" type="text" class="input has-text-centered is-warning is-focused" v-model="code"/>
                        <div class="has-text-danger" v-show="showError">
                            Invalid Code
                        </div>
                        <div cl  v-show="showSent">
                            New code has been sent
                        </div>
                    </div>
                    <div class="body-bott">
                        <button type="submit" id="codeButt" class="button is-warning is-pulled-right">
                            OK
                        </button>
                        <button class="button is-pulled-right" @click="cancel">
                            Cancel
                        </button>
                        <br>
                    </div>
                </form>
            </div>

           
        </div>
    </div>
</template>

<script>
export default {
  data: function () {
    var code = ''
    var cu = {}
    return {
      code,
      cu,
      showError: false,
      showSent: false
    }
  },
  mounted: function () {
      document.getElementById("textInput").focus();
  },
  methods: {
    checkCode: function () {
      var self = this

      this.showSent = false
      this.showError = false

      if (this.code == '') {
        return
      }

      az.addRemSpinner(true, 'id', 'codeButt');

      self.$root.azCognito.checkVerificationCode(self.code, verificationEmailCallback)

      function verificationEmailCallback (result, obj) {
        az.addRemSpinner(false, 'id', 'codeButt');
        if (result == 'error') {
          if (obj.code == 'CodeMismatchException') {
            self.showError = true
          }
          return
        }
        self.$root.userAttrs.email_verified = true
        self.$root.isAuth = true
        self.$emit('close')
      }
    },
    resend: function () {
      var self = this
      self.showSent = false
      self.showError = false

      self.$root.azCognito.resendVerificationCode(resendCodeCallback)

      function resendCodeCallback (result, obj) {
        if (result == 'error') {
          if (obj.code == 'LimitExceededException') {
            self.$root.showModalOK({message: 'You have reached the limit for codes sent within a time period. Please try again later.'})
          }
          return
        }
        self.showSent = true
      }
    },
    cancel: function () {
      this.$root.azCognito.logOutUser(null)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
    .modal-container{
        width: 350px;
        min-height: 330px;
        border-top: 8px solid #ffcb57;
        border-radius: 15px;
        overflow: hidden;
        padding: 10px
    }
    .body-bott{
        position: relative;
        margin-left: -10px;
        top: 20px;
        right: 10px;
        width: 100%;
    }
    .body-bott .button{
        margin-left: 10px;
        /* position: absolute;
        right: 30px;
        bottom: 10px; */
    }
    #textInput{
        width: 150px;
    }
    a{
        font-weight: bold;

    }
    a:hover{
        color:gold
    }
</style>



// WEBPACK FOOTER //
// src/components/ModalVerifyCode.vue